export default "__VITE_ASSET__DYiYCiRQ__"